import {isNullOrUndefined} from 'util';
import {isEmpty} from 'lodash';
import {AbstractControl} from '@angular/forms';
import {Moment} from 'moment';

const moment = require('moment');

export class DateUtils {
    public static INNER_DATE_FORMAT = 'DD.MM.YYYY'

    public static isDateNearOffset(control: AbstractControl, offsetMoment: () => Moment): boolean {
        let valueDate  = control && control.value;

        if (isNullOrUndefined(valueDate) || isEmpty(valueDate)) { return false; }

        if (!moment(valueDate, DateUtils.INNER_DATE_FORMAT, true).isValid()) {
            return false;
        }

        let offsetDate = offsetMoment().toDate();

        return moment(valueDate, DateUtils.INNER_DATE_FORMAT).toDate() <= offsetDate;
    }

    public static isDateNearestOffset(control: AbstractControl, offset: number, offsetUnit: any): boolean {
        return DateUtils.isDateNearOffset(control, () => moment().add(offset, offsetUnit))
    }

    public static now() {
        return moment();
    }

    public static future() {
        return moment().add(100, 'years');
    }

    public static yearsBefore(yearsBefore: number) {
        return moment().subtract(yearsBefore, 'years');
    }

    public static past() {
        return moment().subtract(100, 'years');
    }

    public static maxDateOfBirth() {
        return moment().subtract(18, 'years');
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/date.utils.ts